<template>
  <div class="calendar-box" ref="calendarBox">
    <div class="row">
      <div class="calendar-col fixed" v-show="showFixedHeader">
        <div class="col-item" v-for="(day, index) in dayList" :key="index">
          <div
            :class="index == 3 ? 'day-head act' : 'day-head'"
            @click="$emit('handleFn', day.fullDate)"
          >
            {{ day.day }}
            <span>{{ day.week }}</span>
          </div>
        </div>
        <el-button type="text" @click="changeWeek(-7)" class="btn-weekly-change prev"><i class="el-icon-arrow-left"></i></el-button>
        <el-button type="text" @click="changeWeek()" class="btn-weekly-change next"><i class="el-icon-arrow-right"></i></el-button>
      </div>

      <ul class="hours-row">
        <li v-for="(hours, index) in hoursList" :key="index">
          <span class="hours-str">{{ hours }}</span>
        </li>
      </ul>
      <div class="calendar-col">
        <div class="col-item" v-for="(day, index) in dayList" :key="index">
          <div
            :class="index == 3 ? 'day-head act' : 'day-head'"
            @click="$emit('handleFn', day.fullDate)"
          >
            {{ day.day }}
            <span>{{ day.week }}</span>
          </div>
        </div>
      </div>
      <div class="card-list">
        <div
          :class="card.approve ? 'card-item approve' : 'card-item'"
          v-for="(card, index) in dataList"
          :key="index"
          :style="card.style"
        >
          <div class="card-content">
            <el-popover
              width="400"
              popper-class="schedule-popover"
              trigger="hover"
            >
              <div :class="card.approve ? 'popover-box approve' : 'popover-box'">
                <div class="ta-r" v-if="showHandle">
                  <el-button type="text" @click="() => $emit('showSoldSeat', card.scheduleId)">
                    <i class="el-icon-s-operation"></i>
                  </el-button>
                  <el-button type="text" @click="gotoBooking(card.onlineBookingUrl)">
                    <i class="el-icon-link"></i>
                  </el-button>
                  <el-button type="text" @click="toEdit(card.scheduleId)">
                    <i class="el-icon-edit-outline"></i>
                  </el-button>
                  <el-button type="text" @click="deleteSchedule_fn(card.scheduleId)">
                    <i class="el-icon-delete"></i>
                  </el-button>
                </div>
                <div class="box">
                  <h2 class="movie-name">{{ card.popover.filmName }}</h2>
                  <el-tag :type="card.approve ? 'warning' : 'info'" v-if="card.popover.versionName != ''">
                    {{card.popover.versionName}}
                  </el-tag>
                </div>
                <div class="box">
                  <p class="show-time">
                    {{ $moment(card.popover.startTime).format("HH:mm") }} -
                    {{ $moment(card.popover.endTime).format("HH:mm") }}
                  </p>
                  <el-tag :type="card.approve ? 'warning' : 'info'">{{ card.popover.houseName }}</el-tag>
                </div>
              </div>
              <div slot="reference">
                <p :title="card.slot.filmName">{{ card.slot.filmName }}</p>
                <el-tag
                  v-if="card.slot.versionName != ''"
                  :type="card.approve ? 'warning' : 'info'"
                  :title="card.slot.versionName"
                >
                  {{ card.slot.versionName }}
                </el-tag>
                <p :title="$moment(card.slot.startTime).format('HH:mm') + ' - ' + $moment(card.slot.endTime).format('HH:mm')">
                  {{ $moment(card.slot.startTime).format("HH:mm") }} - {{ $moment(card.slot.endTime).format("HH:mm") }}
                </p>
                <el-tag
                  :type="card.approve ? 'warning' : 'info'"
                  :title="card.slot.houseName"
                >
                  {{ card.slot.houseName }}
                </el-tag>
              </div>
            </el-popover>
          </div>
        </div>
      </div>
    </div>
    <el-button type="text" @click="changeWeek(-7)" class="btn-weekly-change prev"><i class="el-icon-arrow-left"></i></el-button>
    <el-button type="text" @click="changeWeek()" class="btn-weekly-change next"><i class="el-icon-arrow-right"></i></el-button>
  </div>
</template>

<script>
import { formatCalenderList } from "@/assets/js/schedule.js";
import countDownAlert from "@/utils/countDownAlert";
import { weekLocaleArray } from "@/utils/common";
import { deleteSchedule } from "@/helpers/service/api/schedule.js";

export default {
  name: "ScheduleTabCalender",
  props: {
    targetDay: {
      type: String,
      default: ""
    },
    scheduleList: {
      type: Array,
      default: () => []
    },
    filmList: {
      type: Array,
      default: () => []
    },
    showHandle: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      showFixedHeader: false,
    };
  },
  computed: {
    hoursList() {
      let hours_arr = [];
      for (let i = 0; i < 24; i++) {
        if (i >= 10) {
          hours_arr.push(i + ":00");
        } else {
          hours_arr.push("0" + i + ":00");
        }
      }

      return [ ...hours_arr ];
    },
    dayList() {
      return this.getWeek(this.targetDay);
    },
    dataList() {
      let result = [];
      if (this.scheduleList.length > 0) {
        result = formatCalenderList(
          this.scheduleList,
          this.dayList[0].fullDate,
          this.filmList
        );
      }

      return result;
    },
  },
  mounted() {
    window.addEventListener("scroll", this.windowScrollAction, false);
  },
  destroyed() {
    window.removeEventListener("scroll", this.windowScrollAction);
  },
  methods: {
    getWeek(targetDay) {
      let arr = [];
      let week = [ ...weekLocaleArray ];

      arr.push({
        day: this.$moment(targetDay).format("D"),
        week: week[this.$moment(targetDay).day()],
        fullDate: this.$moment(targetDay).format("YYYY-MM-DD")
      });

      for (let i = 1; i < 4; i++) {
        arr.push({
          day: this.$moment(targetDay)
            .add(i, "days")
            .format("D"),
          week:
            week[
              this.$moment(targetDay)
                .add(i, "days")
                .day()
            ],
          fullDate: this.$moment(targetDay)
            .add(i, "days")
            .format("YYYY-MM-DD")
        });
        arr.unshift({
          day: this.$moment(targetDay)
            .add(-i, "days")
            .format("D"),
          week:
            week[
              this.$moment(targetDay)
                .add(-i, "days")
                .day()
            ],
          fullDate: this.$moment(targetDay)
            .add(-i, "days")
            .format("YYYY-MM-DD")
        });
      }

      return arr;
    },
    changeWeek(num = 7) {
      let targetDay = this.$moment(this.targetDay)
        .add(num, "days")
        .format("YYYY-MM-DD");

      this.$emit("handleFn", targetDay);
    },
    toEdit(id) {
      let link = "/schedule/edit/" + id;
      this.$router.push({ path: link });
    },
    deleteSchedule_fn(scheduleId) {
      const confirmHtml = `
        <i class="egl-confirm-question">?</i>
        <span class="result-text">${this.$locale("movie.deleteSchedule")}</span>`;

      this.$confirm(confirmHtml, "", {
        dangerouslyUseHTMLString: true,
        showClose: false,
        showCancelButton: true,
        cancelButtonClass: "egl-btn-white",
        cancelButtonText: this.$locale("global.cancel"),
        showConfirmButton: true,
        confirmButtonClass: "egl-btn-yellow",
        confirmButtonText: this.$locale("global.delete"),
        customClass: "egl-confirm",
        closeOnClickModal: false
      })
        .then(() => {
          // confirm
          const existingDataList = [ ...this.scheduleList ];

          deleteSchedule({ id: scheduleId })
            .then(res => {
              const { success, message } = res;

              if (success && !message) {
                countDownAlert({
                  content: this.$locale("global.deleteSuccessfully"),
                  callback: () => {
                    const resultArray = existingDataList.filter(list => list.scheduleId != scheduleId);
                    this.updateScheduleList(resultArray);
                  }
                });
              }
            });

        });
    },
    gotoBooking(url) {
      window.open(url);
    },
    windowScrollAction() {
      const targetHeight = Number(this.$refs.calendarBox.offsetTop);
      this.showFixedHeader = window.scrollY > targetHeight;
    },
    updateScheduleList(_value) {
      this.$emit("update:scheduleList", _value);
    },
  },
};
</script>

<style scoped lang="less">
@calendarHeaderHeight: 100px;
@calendarTimeZoneWidth: 65px;

  .calendar-box {
    color: @primary-black;
    flex: 1 1;
    overflow: auto;
    position: relative;
    border-radius: 5px;
    background-color: @light-grey-bg;

    .row {
      overflow-y: auto;
      padding: @calendarHeaderHeight 0 0 @calendarTimeZoneWidth;
      position: relative;

      .hours-row {
        margin: 0;
        padding: 0;
        background-color: @pure-white;

        li {
          border-top: 1px dashed @primary-light-grey;
          box-sizing: border-box;
          height: 120px;
          position: relative;
          text-align: left;

          .hours-str {
            color: @other-grey;
            display: inline-block;
            font-size: 1rem;
            line-height: 30px;
            position: absolute;
            top: -15px;
            left: -@calendarTimeZoneWidth;
            text-align: center;
            width: @calendarTimeZoneWidth;
          }
        }
      }

      .calendar-col {
        display: flex;
        justify-content: center;
        padding-top: @calendarHeaderHeight;
        position: absolute;
        top: 0;
        left: @calendarTimeZoneWidth;
        right: 0;
        bottom: 0;
        text-align: center;
        transition-duration: 250ms;

        .col-item {
          border-right: 1px solid @primary-light-grey;
          box-sizing: border-box;
          width: 14%;

          &:first-child {
            border-left: 1px solid @primary-light-grey;
          }

          .day-head {
            height: @calendarHeaderHeight - 40px;
            line-height: 30px;
            margin: -@calendarHeaderHeight auto auto auto;
            padding: 20px 0;
            color: @other-grey;
            cursor: pointer;
            font-size: 1.2rem;
            text-align: center;
            transition-duration: 500ms;

            &.act {
              background-color: @primary-yellow;
              color: @primary-black;
              pointer-events: none;
            }

            &:hover:not(.act) {
              background-color: @secondly-light-grey;
            }

            span {
              display: block;
            }
          }
        }

        &.fixed {
          position: fixed;
          z-index: 10;
          top: 60px;
          left: 170px;
          right: 25px;
          height: 0;
          background: @light-grey-bg;

          &::before {
            content: "";
            position: absolute;
            width: @calendarTimeZoneWidth;
            height: 100px;
            left: -@calendarTimeZoneWidth;
            top: 0;
            background: @light-grey-bg;
          }

          .btn-weekly-change.prev {
            margin-left: -@calendarTimeZoneWidth;
          }
        }
      }
    }

    .card-list {
      overflow: hidden;
      position: absolute;
      top: @calendarHeaderHeight;
      left: @calendarTimeZoneWidth;
      right: 0;
      bottom: 0;

      .card-item {
        box-sizing: border-box;
        height: @calendarHeaderHeight;
        margin-left: 1%;
        margin-top: 1px;
        overflow: hidden;
        padding: 8px;
        position: absolute;
        top: 0;
        left: 0;
        text-align: left;
        background-color: @light-grey-bg;
        background-image: linear-gradient(90deg, @primary-light-grey 0, @light-grey-bg 2px);

        .hours-str {
          color: @other-grey;
          display: inline-block;
          font-size: 16px;
          line-height: 30px;
          position: absolute;
          top: -15px;
          left: -@calendarTimeZoneWidth;
          text-align: center;
          width: @calendarTimeZoneWidth;
        }

        &.approve {
          background-color: @secondly-orange;
          background-image: linear-gradient(90deg, @popover-orange 0, @secondly-orange 2px);
        }

        .card-content {
          p {
            color: @primary-black;
            font-size: 1rem;
            margin: 0;
            line-height: 30px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          span {
            margin-bottom: 10px;
          }
        }
      }
    }

    // .el-icon-arrow-left,
    // .el-icon-arrow-right {
    //   cursor: pointer;
    //   position: absolute;
    //   top: 50px;
    //   left: 20px;
    // }

    // .el-icon-arrow-right {
    //   left: auto;
    //   right: 20px;
    // }

    .btn-weekly-change {
      position: absolute;
      z-index: 10;
      top: 25px;
      width: 50px;
      height: 50px;
      margin: 0;
      padding: 0;

      i {
        font-size: 2rem;
      }

      &.prev {
        left: 10px;
      }

      &.next {
        right: 0;
      }
    }
  }

  .el-main.menu-ext {
    .calendar-col.fixed {
      margin-left: 235px;
    }
  }
</style>
